// extracted by mini-css-extract-plugin
module.exports = {"container":"AvatarIconStack_container__3LEVa","remainingNumber":"AvatarIconStack_remainingNumber__1f5el"};